export enum QueryOperation {
  Equal = 0,

  NotEqual = 1,
  LessThan = 2,
  LessThanOrEqual = 3,
  GreaterThan = 4,
  GreaterThanOrEqual = 5,
  Contains = 6,
  NotContains = 7,
  StartsWith = 8,
  NotStartsWith = 9,
  EndsWith = 10,
  NotEndsWith = 11,

  Between = 12,
  NotBetween = 13,

  Sub = 14,

  In = 15,
  NotIn = 16,
}

export enum QueryCase {
  Default = 0,
  Lower = 1,
  Upper = 2,
}

export interface QueryCondition {
  readonly field: string;
  readonly operation: QueryOperation;
  readonly values: (string | number | boolean)[];
  readonly case?: QueryCase;
}

export interface SearchQuery {
  readonly conditions: QueryCondition[];
}
